import { DisplayField, StepperContext } from '@digitools/honest-ui';
import React, { useContext } from 'react';
import useAsDataContext from '../../hooks/useAsDataContext';
import useTranslate from 'src/hooks/useTranslate';
import { reviewGettingStartedText } from '../../constants/reviewGettingStartedText';
import { ReviewText } from '../../constants/ReviewText';
import { CustomEmployeeIdText } from 'src/utils/CustomExperienceText';
const ReviewGettingStarted = () => {
    const { claimantData } = useAsDataContext();
    const { t } = useTranslate();
    const stepper = useContext(StepperContext);
    // DisplayField entries only take label/value, so data-private and test ids go on a span inside the value.
    // Only the last 4 of the SSN show; screen readers hear "ending in 6789" instead of five "bullet"s.
    const fields = [
        ...(claimantData?.ssn
            ? [{
                    label: t(reviewGettingStartedText.ssnLabel),
                    value: (<span data-private={true} data-testid='ssnField'>
              <span aria-hidden={true}>{'•'.repeat(Math.max(claimantData.ssn.length - 4, 0))}</span>
              <span className='hui-visually-hidden'>{t(reviewGettingStartedText.ssnEndingText)} </span>
              {claimantData.ssn.slice(-4)}
            </span>),
                }]
            : []),
        ...(claimantData?.empId
            ? [{
                    label: CustomEmployeeIdText(t(reviewGettingStartedText.employeeIdLabel)),
                    value: <span data-private={true} data-testid='empIdField'>{claimantData.empId}</span>,
                }]
            : []),
    ];
    return (<div data-testid='gettingStartedReview'>
      <DisplayField title={t(reviewGettingStartedText.reviewGettingStartSubHeading)} headingLevel='h3' className='hui-mb-lg' columns={1} fields={fields} onEdit={() => { stepper.edit(0); }} 
    // Passed explicitly: the app wraps honest-react's LanguageProvider, not honest-ui's, so the default would stay English
    editLabel={t(ReviewText.editButton)}/>
    </div>);
};
export default ReviewGettingStarted;
